// extracted by mini-css-extract-plugin
export default {"icon":"DanhSachHoSo_icon__Z57DQ"};